import React, { Component } from 'react';

import './css/CareerItem.css';

export default class CareerItem extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		const { link } = this.props;
		const win = window.open(link, '_blank');
  	win.focus();
	}

	render() {
		return (
			<li className="timeline-inverted">
				<div className="timeline-image" onClick={this.handleClick}>
					<img className="img-circle img-responsive" src={this.props.timelineImage} alt={this.props.imgAlt} />
				</div>
				<div className="timeline-panel-body timeline-panel">
					<div className="timeline-heading">
						<h4>{this.props.date}</h4>
						<h4 className="subheading">{this.props.title}</h4>
					</div>
					<div className="timeline-body">
						<p className="text-muted">{this.props.description}</p>
					</div>
				</div>
			</li>
		);
	};
}



// WEBPACK FOOTER //
// ./src/components/CareerItem.jsx